import {
  Box,
  Button,
  Heading,
  Input,
  InputProps,
  Stack,
  useToast,
} from "@chakra-ui/react";
import { PageBlockBreakpoint } from "lib/gcms";
import React, { useState } from "react";
import { fmtThemeColor } from "utils";

export const WaitlistSection = ({
  title,
  content,
  color,
  bg,
}: PageBlockBreakpoint) => {
  const [email, setEmail] = useState("");
  const toast = useToast();
  const handleSubmit = async (e: React.FormEvent<any>) => {
    e.preventDefault();
    try {
      const res = await fetch("/api/waitlist", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          email,
        }),
      });
      const res_1 = await res.json();
      toast(
        res_1.success
          ? {
              title: "Thank You For Joining!",
              description: "Check your inbox for a confirmation email",
              status: "success",
              duration: 5000,
              isClosable: true,
            }
          : {
              title:
                "We're sorry, but we were unable to process your email at this time",
              description: "An internal server error occurred",
              status: "warning",
              duration: 5000,
              isClosable: true,
            },
      );
      if (res_1.success) {
        setEmail("");
      }
    } catch (e_1) {
      return console.error(e_1);
    }
  };
  const getColorRoots = (
    color: string,
  ): {
    color: string;
    value: number;
  } => {
    const attributes = color.includes(".")
      ? color.split(".")
      : color.split("_");

    return {
      color: attributes[0],
      value: parseInt(attributes[1]) > 50 ? parseInt(attributes[1]) : 100,
    };
  };

  return (
    <Stack
      as="section"
      px={{ base: "6", md: "8" }}
      py="12"
      bg={fmtThemeColor(bg)}
      color={color}
      alignItems="center"
      flexDirection="column"
    >
      <Box
        textAlign="center"
        maxW={{ base: "md", md: "xl" }}
        mx="auto"
        px={{ base: "6", md: "8" }}
        py="12"
        flex="1"
      >
        <Heading
          size="2xl"
          letterSpacing="tight"
          fontWeight="extrabold"
          lineHeight="normal"
        >
          {title}
        </Heading>
        <Box my="5" fontSize="lg">
          {content}
        </Box>
        <SubscribeForm
          onSubmit={handleSubmit}
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          colorScheme={getColorRoots(bg).color}
          _focus={{
            boxShadow: `0 0 0 1px ${getColorRoots(bg).color}.${
              getColorRoots(bg).value + 300
            }`,
            borderColor: `${getColorRoots(bg).color}.${
              getColorRoots(bg).value + 300
            }`,
          }}
        />
      </Box>
    </Stack>
  );
};
const SubscribeForm = ({
  onSubmit,
  colorScheme,
  ...props
}: {
  onSubmit: (e: React.FormEvent) => Promise<void>;
  colorScheme: string;
} & InputProps) => {
  return (
    <form onSubmit={onSubmit}>
      <Stack spacing="4" direction={{ base: "column", sm: "row" }}>
        <Input
          type="email"
          placeholder="Enter your Email"
          bg="white"
          {...props}
        />
        <Button colorScheme={colorScheme} px="10" type="submit">
          Join Now
        </Button>
      </Stack>
    </form>
  );
};
